import type { Game } from '@game/types'

/**
 * A complete but inert `Game` for the `/preview/*` tile pages: the tile components
 * read `name` and `game_hero_colour`, and every other field is a neutral value that
 * enables nothing (no jackpot, no video, no assets to look up).
 */
export function previewGame(name: string, heroColour?: string): Game {
    return {
        id: 'preview',
        name,
        updated_at: '1970-01-01T00:00:00Z',
        slug: 'preview',
        provider_slug: 'preview',
        vendor_slug: 'preview',
        sort_index: 0,
        tile_type: 'DEFAULT',
        game_type: 'SLOTS',
        game_subtype: 'COLLECTOR',
        is_active: true,
        is_new: false,
        is_exclusive: false,
        is_recommended: false,
        is_staff_only: false,
        has_jackpot: false,
        opening_hours: { is_open: true, opens_at: null },
        attributes: {},
        headline: '',
        description: '',
        full_description: '',
        game_hero_colour: heroColour ?? null,
        asset_availability: {},
    }
}
